// Reset console chrome (breadcrumbs + sub-bar status) before each navigation.
// Pages set their own values in setup, which runs after this middleware, so this
// only clears leftovers from the previous route.
export default defineNuxtRouteMiddleware(() => {
  useBreadcrumbs().value = []
  useSubbarStatus().value = null
})
